import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  DSButton,
  DSRADIO_BUTTON_POSITION,
  DSRadio,
  useToast,
} from '@repo/design-system/index'
import { QIcon_book } from '@repo/icons/index'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import apis from '../../../../../modules/apis'
import { axiosPost } from '../../../../../modules/axiosHelper'
import { useCurrentUser } from '../../../../../modules/context/UserContext'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import {
  n_upcoming_lessons,
  s_common,
  s_schedule,
  s_upcoming_lessons,
} from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { COLORS, MATCHING_AFTER } from '../../../../../modules/vars'
import { useBasicPopup } from '../../../../basic/popup/BasicPopup'
import CreditBadge from '../../../../common/buttons/CreditBadge'
import TutorAvatar from '../../../../new-portal/lessons/TutorAvatar'

interface ChangeMatchingOptionModalPropsInterface {
  lesson: any
  onHide: any
  isBooked: boolean
  onChangeOptionOnWebview?: any
}

const ChangeMatchingOptionModal = ({
  lesson,
  onHide,
  isBooked,
  onChangeOptionOnWebview,
}: ChangeMatchingOptionModalPropsInterface) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { currentUser } = useCurrentUser()
  const isMobile = useIsMobile()
  const data = {
    radioGroup: {
      name: 'option',
      items: [
        {
          name: (
            <div className="mb-[4px]">
              {t(n_upcoming_lessons.popup_tutor_maching_option.maching_another_tutors)}
              <>
                {isBooked && (
                  <div className="px-[2px] pt-[2px] text-[12px] font-normal text-red-500">
                    {t(s_schedule.after_cancel_auto_matching_unavailable)}
                  </div>
                )}
              </>
            </div>
          ),
          value: MATCHING_AFTER.AUTOMATIC_MATCHING_ME,
          disabled: isBooked ? true : false,
        },
        {
          name: t(n_upcoming_lessons.popup_tutor_maching_option.restore_credit),
          value: MATCHING_AFTER.CANCEL_RESTORE_CREDIT,
          disabled: false,
        },
      ],
    },
  }
  const basicPopup = useBasicPopup()
  const [option, setOption] = useState(lesson?.matching_after_option)
  const { toastSuccess } = useToast()
  console.log(option)

  const disabled = option == lesson?.matching_after_option || option == null

  const handleSubmit = async (e) => {
    if (onChangeOptionOnWebview) {
      onChangeOptionOnWebview(e, option)
      return
    }
    if (disabled) return
    e.preventDefault()
    const response = await axiosPost(apis.lessons.preparation.option(lesson.id), {
      option: option,
    })
    if (response.success) {
      queryClient.invalidateQueries([apis.lessons.upcomingsV5()])
      basicPopup.close('changeMatchingOptionModal')
      toastSuccess(t(s_upcoming_lessons.after_tutor_cancel.your_option_change_has_been_completed))
    } else {
      alert(response.message)
    }
    e.stopPropagation()
  }

  const courseTitle = lesson?.course?.title
    ? lesson?.course?.title
    : lesson?.course_title
    ? lesson?.course_title
    : t(n_upcoming_lessons.edit_materials.tab_desc)

  return (
    <div className="mx-16 mt-[16px] flex h-full flex-col bg-gray-50 sm:mx-0 md:bg-white">
      <div className="flex flex-col space-y-[20px]">
        <div className="boxBorder border-1 border-b-1 relative flex min-w-0 flex-col break-words rounded-lg border-gray-200 bg-white p-[16px]">
          <div className="mt-[8px] mb-[0px] h-auto border-gray-200 bg-transparent p-[0px]">
            <div className="mx-[0px] mb-[8px] flex items-start rounded-[10px]">
              <div className="flex items-center gap-12">
                <div className="">
                  {/** style hard coding */}
                  <CreditBadge
                    duration={lesson?.duration}
                    style={{
                      paddingTop: '6px',
                      paddingBottom: '6px',
                      paddingLeft: '8px',
                      paddingRight: '8px',
                      color: '#140F33',
                      backgroundColor: 'rgb(228, 231, 244)',
                      fontWeight: 'bold',
                      height: '30px',
                    }}
                  />
                </div>
                <div className="mx-[0px] flex items-center justify-center rounded-lg leading-6">
                  {lesson?.tutor_canceled && lesson?.matching_after_option == MATCHING_AFTER.SHOW_AVAILABLE_TIMES ? (
                    <div className="sm:p-0">
                      <span className="mb-[0px] mr-[3px] h-[30px] text-[20px] font-bold text-gray-300 line-through">
                        {lesson?.formatted_start_time}
                      </span>
                    </div>
                  ) : (
                    <div className="sm:p-0">
                      <span className="mb-[0px] mr-[3px] h-[30px] text-[20px] font-bold text-black">
                        {lesson?.formatted_start_time}
                      </span>
                    </div>
                  )}
                  <div className="text-sm font-medium text-gray-500">{currentUser?.timezone}</div>
                </div>
              </div>
            </div>
            <div className="mx-[0px] mb-[24px] flex-col items-center rounded-lg">
              <TutorAvatar tutor={lesson?.tutor} />
            </div>
            <div className="mx-[0px] flex-col items-center rounded-lg">
              <div className="flex-1">
                <div className="mx-[0px] mt-[8px] items-center rounded-lg">
                  <span className="flex text-[14px] text-gray-700">
                    <QIcon_book width="20px" height="20px" />
                    <span className="ml-[4px] font-bold text-gray-700">{courseTitle}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex rounded-[10px] bg-gray-100 p-[16px]">
          <span className="text-[14px] font-bold text-gray-700">
            {t(n_upcoming_lessons.popup_tutor_maching_option.subtitle)}
          </span>
        </div>
        <div>
          <DSRadio
            controlSelected={[option, setOption]}
            buttonPosition={DSRADIO_BUTTON_POSITION.LEFT}
            containerClassName="mt-[8px] flex flex-col space-y-[8px] sm:grid sm:grid-cols-1 sm:gap-[8px] text-[14px]"
          >
            <>
              {data.radioGroup.items.map((setting, idx) => {
                console.log('data.radioGroup.items', setting)
                return (
                  <DSRadio.Item key={idx} value={setting.value} disabled={setting.disabled}>
                    <div className="keep-all">{setting.name}</div>
                  </DSRadio.Item>
                )
              })}
            </>
          </DSRadio>
        </div>
      </div>
      <div className="mt-auto mb-[34px] flex justify-center sm:mb-0 sm:mt-[40px] sm:justify-end">
        <div className="mr-[16px] hidden sm:flex">
          <DSButton size={BUTTON_SIZE.MD} type={BUTTON_TYPE.OUTLINE} onClick={(e) => onHide()}>
            {t(s_common.cancel)}
          </DSButton>
        </div>
        <div className="flex w-full sm:w-fit">
          <DSButton
            size={BUTTON_SIZE.MD}
            type={BUTTON_TYPE.SOLID}
            disabled={disabled}
            onClick={handleSubmit}
            className="border-[1.5px] text-white"
            customBorderColor={COLORS.PURPLE600}
          >
            {isMobile ? '튜터 매칭 옵션 변경하기' : t(s_common.save)}
          </DSButton>
        </div>
      </div>
    </div>
  )
}

export default ChangeMatchingOptionModal
